<template>
  <div class="about container">
    <h1>Vue Form Test Page</h1>

    <hr />
    <vue-form ref="myform" 
            :fields='[{"id":"1a618adfd061330ee801e871a3355ce216","name":"nome","key":"nome","description":null,"type":"string","required":true,"options":null,"default_value":null,"validation":null,"eventId":null,"productId":"1a618adfd061330ee801e871a3355ce2","note":"teste","label":"Nome","value":""},
                {"id":"1a618adfd061330ee801e871a3355ce217","name":"nome-da-assecoria-esportiva","key":"nome-da-assecoria-esportiva","description":null,"type":"string","required":false,"options":null,"default_value":null,"validation":null,"eventId":null,"productId":"1a618adfd061330ee801e871a3355ce2","note":"teste","label":"Nome da Assecoria Esportiva","value":""}
            ]' 
            name="fieldprops" @change="atualizouForm" v-model="fields2">
    </vue-form>
     <div> {{ fields2 }} </div>

    <vue-form ref="myform2" name="testeform" @change="atualizouForm" v-model="fields">
        <vue-field type="string" name="cardnumber" :mask="mask" label="Número do Cartão" :validations="['creditCard']" required></vue-field> 
        {{fields.name}}
   
        <vue-field label="Nome" @change="mudouField"  name="name" @click="clicou" @click.native="clicou" @focus="focus" @blur=""  :required="true" > </vue-field>
        <vue-field label="Email" value="leandro@gmail.com" name="email" :required="true" > </vue-field>
        <vue-field v-if="show" label="CEP"  name="cep" :required="true" > </vue-field>
        <vue-field v-show="show" label="endereco"  name="endereco" :required="true" > </vue-field>
        
        <!-- <vue-field label="Sexo" type="radio" name="sexo"  :options="[{'name':'Masculino',value:'M'},{'name':'Feminino',value:'F'},]" value="" :required="true"> </vue-field> -->
        <!-- <div>
            <vue-field label="E-mail" name="email" :validations="['email']" value="" :required="true">
            </vue-field>
        </div>
         -->
        <!-- <vue-field label="Endereço"  name="address" value="407 norte"> </vue-field>
        <vue-field label="Cor" type="select" name="fruta" :options="[{'name':'Masculino',value:'M'},{'name':'Feminino',value:'F'},]" value="" :required="true"> </vue-field>
        <vue-field label="Data de Nascimento" type="age" name="birthday"  :required="true"> </vue-field>
        <vue-field label="leandro de Nascimento" type="age" name="birthday_le"  :validations="[['age','50','65']]" :required="true" value="1979-06-01T13:00:00"> </vue-field> -->
    </vue-form>

        <div> {{ fields }} </div>


     <hr />


    <hr />

    <button @click="mask='###### ##### ####'" >
       changemask
    </button>
    <button @click="show = !show">
        hide/show fields
    </button>
    <button @click="checkForms">
        Check forms
    </button>

    <button @click="changeFields">
        changeFields
    </button>


  </div>
</template>


<script>

export default {
    props:{
    },
    data(){
        return {
            show:false,
            mask: "#################################",
            fields: { name:""},
            fields2: { name:"Rodrigo Souza Celes"},
       }
    },
    methods:{
        atualizouForm:function(val){
            console.log(val)
            console.log("fields %o",this.fields)
        },

        mudouField:function(val){
            console.log("mudouField: " + val)
        },
        clicou:function(val){
            console.log("clicou: " + val)
        },
        focus:function(val){
            console.log("focus: " + val)
        },


        checkForms:async function(){
            this.fields.name="LELEEEEEEE"
            var error = await this.$refs.myform.hasError();
            var values = this.$refs.myform.getValues();
            var error = await this.$refs.myform2.hasError();
            var values = this.$refs.myform2.getValues();

        },

        changeFields:async function(){
            this.fields.name="LELEEEEEEE"
            this.fields.name="MUDOUEMAIL@GMAIL.COM"
            // var error = await this.$refs.myform.hasError();
            // var values = this.$refs.myform.getValues();

        }
    }
}
</script>


